import axiosHttp from "services/axiosHttp";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const updateUnitDetails = createAsyncThunk("updateUnitDetails", async ({ channelId, unitData }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.patch(`channel/${channelId}/unitdetails`, unitData);
		return response.data;
	} catch (error) {
		return rejectWithValue(error.response.data);
	}
});
const updateUnitDetailsSlice = createSlice({
	name: "updateUnitDetails",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},
	extraReducers: (builder) => {
		builder
			.addCase(updateUnitDetails.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(updateUnitDetails.fulfilled, (state, action) => {
				state.isLoading = false;
				state.data = action.payload;
			})
			.addCase(updateUnitDetails.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.payload || "An error occurred while updating the unit details.";
			});
	},
});

export default updateUnitDetailsSlice.reducer;
